import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@repo/ui";
import AnimatedCard from "../../../../components/AnimatedCard/AnimatedCard";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import StepIndicator from "../../../../components/StepIndicator/StepIndicator";
import withAuth from "../../../../hoc/withAuth/withAuth";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";
import { getWithdrawSteps } from "../../constants/steps";

const LOCALE =
  "modules_MyGiftTable_pages_WithdrawPage_WithdrawPageStep6ManualSuccess";

const WithdrawPageStep6ManualSuccess: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const steps = getWithdrawSteps(t);
  const navigate = useNavigate();

  const handleFinish = () => navigate("/my-table");

  return (
    <PageContainer>
      <div className="mt-16" />
      <StepIndicator steps={steps} currentStep={5} progressPercentage={100} />
      <AnimatedCard className="bg-white max-w-lg w-full">
        <h2 className="text-2xl font-bold mb-4 text-primary">
          {t("successHeading", "¡Listo! Estamos procesando tu retiro")}
        </h2>
        <p className="text-gray-600 mb-6">
          {t(
            "successBody",
            "Recibimos tus datos. Nuestro equipo los validará y continuará con tu retiro. Te notificaremos cualquier actualización."
          )}
        </p>
        <Button
          label={t("finish", "Volver a mi mesa")}
          onClick={handleFinish}
          type="primary"
          className="w-full"
        />
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(WithdrawPageStep6ManualSuccess));
